<template>
  <div
    class="form-group form-group--datepicker"
    :class="getClass()"
  >
    <div class="row">
      <div :class="`col-sm-${component.size}`">
        <label>{{ component.label }}
          <span
            v-if="isRequired()"
            class="required"
          >*</span>
        </label>
        <div class="input-group">
          <the-mask class="form-control"
                    :id="component.key"
                 :type="component.type"
                 :name="component.key"
                 :disabled="disabledHandler()"
                 :placeholder="component.placeholder"
                 :mask="'##/##/####'"
                 :masked="false"
                 v-validate="setRules()"
                 :data-vv-name="component.key"
                 :value="component.data.currentValue"
                 v-model="component.data.currentValue"
                 @focus.native="focusHandler()"
                 @blur.native="blurHandler()"
                 @keyup.13.native="enterHandler()"
          />
           <div class="input-group-addon">
             <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" width="18">
               <g transform="translate(-433 -153)">
                 <rect class="cls-1" width="18" height="18" transform="translate(433 153)"/>
                 <path data-name="Path 1185" class="cls-2" d="M15.432-6.016H4.568v-8.531H15.432Zm-2.333-14v1.568H6.9v-1.568H5.333v1.568H4.568a1.529,1.529,0,0,0-1.13.438A1.529,1.529,0,0,0,3-16.88V-6.016A1.513,1.513,0,0,0,3.456-4.9a1.513,1.513,0,0,0,1.112.456H15.432A1.513,1.513,0,0,0,16.544-4.9,1.513,1.513,0,0,0,17-6.016V-16.88a1.5,1.5,0,0,0-.456-1.13,1.546,1.546,0,0,0-1.112-.437h-.766v-1.568Zm.651,8.262h-4v4h4Z" transform="translate(432.25 173.754)"/>
               </g>
             </svg>
           </div>
        </div>
        <span
          v-if="errors.has(component.key)"
          class="help-block help-block--bottom"
        >
          <svg
            viewBox="0 0 14 14"
            width="14"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g transform="translate(-252 -635)">
              <rect
                class="cls-1"
                height="14"
                transform="translate(252 635)"
                width="14"
              />
              <path
                class="cls-2"
                d="M7.4,9.8H8.6V11H7.4ZM7.4,5H8.6V8.6H7.4Zm.594-3A6,6,0,1,0,14,8,6,6,0,0,0,7.994,2ZM8,12.8A4.8,4.8,0,1,1,12.8,8,4.8,4.8,0,0,1,8,12.8Z"
                transform="translate(251 634)"
              />
            </g>
          </svg>
          {{ errors.first(component.key) }}</span>
        <span
          v-if="!errors.has(component.key) && component.description"
          class="help-block help-block--bottom"
        >{{ component.description }}</span>
      </div>
    </div>
  </div>
</template>

<script>
// Mixins
// https://br.vuejs.org/v2/guide/mixins.html
import component from '@/mixins/component'

// Utils
import { TheMask } from '@/directives/mask'
import moment from 'moment'

export default {
  mixins: [component],
  props: ['component'],
  inject: ['$validator'],
  name: 'component-datepicker',
  components: {
    TheMask
  },
  data () {
    return {
      isFocus: false,
      isValue: false,
      isErrors: false
    }
  },
  created () {
    // Valor Padrão (Data Atual)
    if (this.component.data.defaultValueToday) {
      this.component.data.defaultValue = moment().format('DDMMyyyy')
    }

    this.setValue()
  }
}
</script>
